<template>
  <div class="position-absolute p-header">
    <div class="col-12">
      <div class="row">
        <div
          class="col-12 ps-4 pe-4 d-flex align-items-center justify-content-end theme-header"
        >
          <button @click="$router.go(-1)" class="btn-back"></button>

          <p class="m-auto">{{ this.displayHeading }}</p>
          <a href="#" class="btn-back opacity-0"></a>
          <img src="/img/ui-theme/call.png" height="28" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "../global";
import { unslugify } from "unslugify";

export default {
  name: "ViewTopNav",
  props: ["heading", "subheading"],
  data() {
    return {
      componentName: "AssetType",
    };
  },
  setup() {
    const { theme } = global;
    let displayHeading = "";

    return {
      theme,
      displayHeading,
    };
  },
  created() {
    this.displayHeading = unslugify(this.heading || "");
  },
};
</script>
